module.exports = __webpack_public_path__ + "bae6cbcda2319df7a9a84dd9efaae3b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_xlarge_x1/public/games/Space-Marine_1.jpg
// module id = 326
// module chunks = 0